/**
 * @file automatically generated from MApp.Data.TileOrderState
 */

export enum TileOrderState {
    Queued = 0,
    Running = 1,
    Finished = 2,
    Canceled = 3,
    Error = 4,
    Canceling = 5
}
